/* eslint-disable */
import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import axios from 'axios';


    
function LoadMoreNews(props){ 
    const [posts, setPosts] = useState([]);
    const [islastPage, setIsLastPage] = useState(false);
    const [page, setPage] = useState(2);
    const [category, setCategory] = useState(props.category);

    console.log(props.category);

    function fetchPosts() {
        setPage(page+1);
        const requestURL = "/wp-json/xpansiv/v1/load_more_news/";

        axios.get(requestURL, {
                params: {
                    page: page,
                    category: category,
                }
            })
            .then(res => {
                console.log(res);
                const responseJSON = res.data;
                const newPosts = responseJSON.data;
                setPosts([...posts, ...newPosts]);
                setIsLastPage(responseJSON.is_last_page);
                console.log("posts:", posts);
                console.log("islastPage:", islastPage);
            })
            .catch((error) => console.log("error getting more news", error))
    }



    return (
        <div>
            <div className="more">
                {
                    posts.map((post, key) => {
                        
                        return (

                            <div className="recent_news--box" key={key}>
                                { post.pod &&
                                    <a href={ post.url } className="recent_news--thumbnail" >
                                        <img src={post.pod.url} alt={post.pod.alt}/>
                                    </a>
                                }
                                { !post.pod &&
                                    <a href={ post.url } className="recent_news--thumbnail"  dangerouslySetInnerHTML={ {__html: post.image} }>
                                    </a>
                                }
                                <div className="recent_news--content">
                                    <div className="recent_news--date">{post.formatted_date}</div>
                                    <a href={ post.url } className="recent_news--title">{post.post_title}</a>
                                </div>
                            </div>
                        )

                    })
                }   

            </div>
            { !islastPage &&

                <div className="align-center">
                    <button className="button button_load-more"
                            onClick={(e) => {
                                fetchPosts();
                            }}>
                        Load more
                    </button>
                </div>  
            }
        </div>

    )


}


export default LoadMoreNews;
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/LoadMoreNews.js